<div class="mt-4">
  <div class="mt-4">
    <vti-breadcrumbs>
      <vti-breadcrumb-item i18n-text text="Summary"></vti-breadcrumb-item>
    </vti-breadcrumbs>
  </div>
  <div>
    <main class="mt-4">
      <vti-tabs (onTabClick)="onTabClick($event)">
        <vti-tab i18n-name name="Summary" [index]="'summary'">
          @if (tabSelected() === 'summary') {
            <div class="w-full">
              <app-summary></app-summary>
            </div>
          }
        </vti-tab>
        <vti-tab i18n-name name="Details" [index]="'details'">
          @if (tabSelected() === 'details') {
            <div class="w-full">
              <app-details></app-details>
            </div>
          }
        </vti-tab>
      </vti-tabs>
    </main>
  </div>
</div>
